import { api } from "./api";

export const onBoardingTour = api.injectEndpoints({
  endpoints: (builder) => ({
    getOnboardingTourStatus: builder.query<any, void>({
      query: () => ({
        url: "/Home/GetOnboardingTourStatusForUser",
        method: "GET",
      }),
      providesTags: ["OnBoardingTour"],
    }),
    saveOnboardingTourStatus: builder.mutation<
      any,
      { totalSteps: number; currentStep: number; skipped: boolean }
    >({
      query: (body) => ({
        url: "/Home/SaveOnboardingTourStatus",
        method: "POST",
        body: body,
      }),
      // invalidatesTags: ["OnBoardingTour"],
    }),
  }),
});

export const {
  useGetOnboardingTourStatusQuery,
  useSaveOnboardingTourStatusMutation,
} = onBoardingTour;
